
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from 'next/head';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import RelatedLinks from '../components/RelatedLinks';
import { SITE_URL } from '../lib/site';
// Evergreen facts sourced from CPH's own security-checkpoint page, so no data
// fetching. The FAQ is driven off a key list to keep the markup and the
// FAQPage JSON-LD in sync.
// ponytail: the "worth it" section links to the live number on "/" instead of
// re-fetching it here; add a live fetch if this page ever needs to show the
// number inline.
const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4'];
const HOW_KEYS = ['how_online', 'how_airline', 'how_included'];
// CPH's own booking/info page, verified per-locale via the site's own
// language switcher (no price stated, price varies).
const CPH_BOOKING_URL = {
    en: 'https://www.cph.dk/en/practical/security-checkpoint',
    da: 'https://www.cph.dk/praktisk/sikkerhedskontrol'
};
function FastTrack() {
    const { t, lang } = useTranslation('fast-track');
    const url = lang === 'en' ? `${SITE_URL}/en/fast-track` : `${SITE_URL}/fast-track`;
    const bookingUrl = CPH_BOOKING_URL[lang] || CPH_BOOKING_URL.da;
    const faqs = FAQ_KEYS.map((k, i) => ({ q: t(k), a: t(`a${i + 1}`) }));
    const faqJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map(({ q, a }) => ({
            '@type': 'Question',
            name: q,
            acceptedAnswer: { '@type': 'Answer', text: a }
        }))
    };
    return (<div className="bg-white p-4 sm:p-6 my-auto rounded max-w-3xl mx-auto text-gray-800">
            <Head>
                <title>{t('meta_title')}</title>
                <meta name="description" content={t('meta_description')}/>
                <meta name="robots" content="all"/>
                <link rel="canonical" href={url}/>
                <meta property="og:title" content={t('meta_title')}/>
                <meta property="og:description" content={t('meta_description')}/>
                <meta property="og:url" content={url}/>
                <script type="application/ld+json" 
    // static/trusted content; escape < so no </script> break-out
    dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqJsonLd).replace(/</g, '\\u003c')
        }}/>
            </Head>

            <h1 className="text-2xl sm:text-3xl font-bold">
                {t('page_title')}
            </h1>
            <p className="mt-3 text-gray-600">{t('intro')}</p>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">{t('what_title')}</h2>
                <p className="mt-2 text-gray-700">{t('what_text')}</p>
            </section>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">{t('where_title')}</h2>
                <p className="mt-2 text-gray-700">{t('where_text')}</p>
            </section>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">{t('how_title')}</h2>
                <ul className="mt-2 list-disc list-inside text-gray-700 *:my-1">
                    {HOW_KEYS.map((k) => (<li key={k}>{t(k)}</li>))}
                </ul>
                <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="mt-3 inline-block text-[var(--secondary)] underline">
                    {t('how_cta')}
                </a>
            </section>

            <section className="mt-8 rounded-lg bg-orange-100 p-4 sm:p-5">
                <h2 className="text-xl font-semibold">
                    {t('worth_it_title')}
                </h2>
                <p className="mt-2 text-gray-700">{t('worth_it_text')}</p>
                <p className="mt-2 text-sm text-gray-600">
                    {t('worth_it_note')}
                </p>
                <Link href="/" className="mt-3 inline-block rounded border border-[var(--secondary)] bg-white px-4 py-2 text-[var(--secondary)] hover:bg-[var(--secondary)]/10">
                    {t('worth_it_cta')}
                </Link>
            </section>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">{t('faq_title')}</h2>
                <dl className="mt-4 divide-y divide-gray-200">
                    {faqs.map(({ q, a }, i) => (<div key={i} className="py-4">
                            <dt className="text-lg font-semibold text-gray-900">
                                {q}
                            </dt>
                            <dd className="mt-2 text-gray-700">{a}</dd>
                        </div>))}
                </dl>
            </section>

            <RelatedLinks links={[
            { href: '/', labelKey: 'security_wait_times' },
            {
                href: '/when-to-arrive',
                labelKey: 'link_when_to_arrive'
            },
            { href: '/parking', labelKey: 'link_parking' }
        ]}/>
        </div>);
}
export default FastTrack;

    async function __Next_Translate__getStaticProps__1a1723ec627__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/fast-track',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec627__ as getStaticProps }
  